import { getElement, getElements } from '@by-association-only/theme-utils';
import { register } from '@shopify/theme-sections';
import { getOffsetTop } from '../utils';
const classes = {
  fixed: 'hd-Header-fixed',
  transparent: 'hd-Header-transparent'
};
register('header', {
  onLoad() {
    this.transparentRanges = this.calculateTransparentRanges();
    this.isFixed = this.container.classList.contains(classes.fixed);
    if (!this.isFixed) return;
    this.banner = getElement('.hd-Banner', {
      context: this.container
    });
    this.bannerOffset = getOffsetTop(this.banner);
    this.isTicking = false;
    this.lastKnownY = window.scrollY;
    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);
    this.setupListeners();
    this.updateEl();
  },

  setupListeners() {
    window.addEventListener('scroll', this.onScroll);
  },

  onScroll() {
    this.lastKnownY = window.scrollY;
    this.requestTick();
  },

  requestTick() {
    if (!this.isTicking) requestAnimationFrame(this.updateEl); // If a rAF is already queued we don't want to call another one

    this.isTicking = true;
  },

  updateEl() {
    // Reset the tick so we can capture the next onScroll
    this.isTicking = false; // Do fun stuffs here

    this.container.classList.toggle(classes.transparent, this.bannerIsOverTransparentArea(this.lastKnownY));
  },

  bannerIsOverTransparentArea(y) {
    const yWithOffset = y + this.bannerOffset;
    const {
      offsetHeight: bannerHeight
    } = this.banner;
    return this.transparentRanges.some(range => {
      return range.start <= yWithOffset && yWithOffset + bannerHeight <= range.end;
    });
  },

  calculateTransparentRanges() {
    const transparentElements = getElements(`[data-header-is-transparent-when-over-me]`);
    if (!transparentElements) return [];
    return transparentElements.map(el => this.calculateTransparentRangeForElement(el));
  },

  calculateTransparentRangeForElement(element) {
    const start = getOffsetTop(element);
    return {
      start,
      end: start + element.offsetHeight
    };
  }

});